import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'shopify-connector-panel',
    templateUrl: './shopify.connector.panel.html'
})
export class ShopifyConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Shopify',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.ShopifyInfo',
            ControlType: ShopifyConnectorPanel,
            Default: null
        };
    }
}
